import type { JSX } from 'preact/jsx-runtime';
import type { OfferData } from 'service/offer/model';
import { localize } from 'i18n/localize';

const $t = localize();

export const number = (
	initNumber: string | number = '',
	decimal: number = 0,
	useComma = false,
	useNormalSpace = false,
): string => {
	if (initNumber === '') return initNumber;

	let formatNumber = Number(initNumber); // - pokud neni initNumber cislo, tak se jej snazim na cislo prevest

	if (isNaN(formatNumber) && typeof initNumber === 'string') {
		formatNumber = Number(initNumber.trim().replace(',', '.').replace(' ', ''));
	}

	const thousandsSeparator = useNormalSpace ? '$1 ' : '$1\xa0';

	if (decimal) {
		const newNumber = formatNumber.toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, thousandsSeparator);

		return useComma ? newNumber.replace('.', ',') : newNumber;
	} else {
		return formatNumber.toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, thousandsSeparator);
	}
};

export const phone = (phone: string): string => {
	return phone.replace(/^(\+?[(]?[0-9]{1,5}[)]?)?\s?([0-9]{3})\s?([0-9]{3})\s?([0-9]{3})$/, '$1 $2 $3 $4').trim();
};

export const priceString = (price: string | number, isPriceInPennies = false, useNormalSpace = false): string => {
	const newPrice = Number(price);

	return isPriceInPennies
		? number(newPrice / 100, newPrice % 100 > 0 ? 2 : 0, true, useNormalSpace)
		: number(newPrice, 0, false, useNormalSpace);
};

export const price = (price: string | number, isPriceInPennies = false, useNormalSpace = false): string => {
	return `${priceString(price, isPriceInPennies, useNormalSpace)}${useNormalSpace ? ' ' : '\xa0'}Kč`;
};

export const offerPrice = ({
	price: _price,
	priceByAgreement,
}: Pick<Partial<OfferData>, 'price' | 'priceByAgreement'>): string => {
	if (_price === undefined) return '';
	const { byAgreement, forFree } = localize().offerPrice;

	_price = Number(_price);

	return _price === 0 ? (priceByAgreement ? byAgreement : forFree) : price(_price);
};

export const replaceLineBreaksByTags = (sentence: string): JSX.Element[] => {
	const lines = sentence.split(/(?:\r\n|\r|\n)/g);
	const linesCount = lines.length;

	const rows: JSX.Element[] = [];

	lines.forEach((text, idx) => {
		rows.push(<>{text}</>);

		if (idx < linesCount - 1) {
			rows.push(<br key={idx} />);
		}
	});

	return rows;
};

export const localDate = (timeString?: string) => {
	if (timeString) {
		const date = new Date(timeString);
		return date.toLocaleDateString('cs');
	} else {
		return '';
	}
};

export const formatMonthAndYearInGenitive = (dateValue: number | string | Date) => {
	const date = new Date(dateValue);
	const year = date.getFullYear();
	const month = $t.dates.monthsGenitive[date.getMonth()];

	return `${month} ${year}`;
};
